module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./zh-WUU-HANS.coffee"));
	}, "zh-WUU-HANS");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=[name]!./app/locale/zh-WUU-HANS.coffee
// module id = 247
// module chunks = 100